// extracted by mini-css-extract-plugin
module.exports = {"appKit":"appKit_appKit__5Jivw"};